import { render, staticRenderFns } from "./complaintDrawer.vue?vue&type=template&id=663f6440&scoped=true&"
import script from "./complaintDrawer.vue?vue&type=script&lang=js&"
export * from "./complaintDrawer.vue?vue&type=script&lang=js&"
import style0 from "./complaintDrawer.vue?vue&type=style&index=0&id=663f6440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663f6440",
  null
  
)

export default component.exports